import { render, staticRenderFns } from "./SimpleTeaser.vue?vue&type=template&id=4702f514&shadow"
import script from "./SimpleTeaser.vue?vue&type=script&lang=ts&shadow"
export * from "./SimpleTeaser.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./SimpleTeaser.vue?vue&type=style&index=0&id=4702f514&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SimpleTeaser.vue?vue&type=style&index=1&id=4702f514&prod&lang=scss&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports